<template>
    <button v-if="!showInput" class="btn btn-light btn-sm" type="button" @click="showPasswordField">
        Change password
    </button>

    <div v-else class="row g-0 align-items-center">
        <div class="col-auto">
            <input
                ref="passwordInput"
                v-model="currentData[field.name]"
                :name="field.name"
                :size="field.size"
                :type="isPasswordTextVisible ? 'text' : 'password'"
                class="form-control" :class="{'is-invalid': field.error}"
                required
            />
        </div>

        <div class="col-auto ps-2">
            <Button :active-value="isPasswordTextVisible" @click.native="isPasswordTextVisible = !isPasswordTextVisible">
                <i v-if="isPasswordTextVisible" class="bi bi-eye-slash"/>
                <i v-else class="bi bi-eye"/>
            </Button>

            <Button @click.native="hidePasswordField">
                reset
            </Button>
        </div>
    </div>
</template>

<script>
import Button from "../Button.vue"

export default {
    name: "FormControlTypePassword",
    components: {Button},
    props: {
        field: Object,
        currentData: Object,
    },
    data() {
        return {
            showInput: false,
            storedPassword: undefined,
            isPasswordTextVisible: false,
        }
    },
    methods: {
        showPasswordField() {

            this.showInput = true

            this.storedPassword = this.currentData[this.field.name]
            this.currentData[this.field.name] = ''

            this.$nextTick(() => {
                this.$refs.passwordInput.focus()
            })
        },
        hidePasswordField() {
            this.showInput = false
            this.currentData[this.field.name] = this.storedPassword
            this.isPasswordTextVisible = true
        }
    }
}
</script>

<style scoped>

</style>